import {Component, OnInit} from '@angular/core';
import { ProductServiceResponse } from '../../popup.service/popup.model';
import {MatTooltipModule} from "@angular/material/tooltip";
import {animate, query, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-popup-product-service',
  templateUrl: './product-service.component.html',
  styleUrls: ['./product-service.component.css'],
})

export class ProductServiceComponent implements OnInit {
  public restrictedData: boolean;
  public errorText: string;
  public showContent = true;
  public data: ProductServiceResponse;

  constructor() {
    this.data = {} as ProductServiceResponse ;
    this.errorText = '';
  }

  ngOnInit() {
  }

  public navigateTo(url: string): void {
    window.open(url, '_blank');
  }
}
